import React from 'react';
import PasswordResetForm from '../../containers/password-reset/form.container';
import TopNavBar from '../../containers/top-nav-bar.container';

const PasswordReset = () => (
  <div>
    <TopNavBar />
    <div className="row justify-content-center mt-4 pt-4">
      <div className="col-sm-12 col-md-4">
        <div className="card m-auto">
          <div className="card-block">
            <PasswordResetForm />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default PasswordReset;



// WEBPACK FOOTER //
// ./src/desktop/components/password-reset/index.js